<template>
  <div class="configcontainer">
  <h2>Konfigurace </h2>
    <ProductConfiguratorProgress 
      :activeConfigStep="activConfigStep"
      :configuration="configuration" />
    <div class="config-container">      
      <div class="order-info">
        <div class="images-wrapper"  id="infoBox" ref="infoBox">
           <div class="images-position"
            v-for="(position,index) in this.configuration"
            :key="'pos'+index"
            :style="{'--indexOrder': index}">
            <img v-if="position.selectedOption.img" :src="require('../assets/images/'+position.selectedOption.img)" alt=""
              :style="{ width: width + 'px'}" style="max-width: calc(100vw - 40px)"
            >

            </div>
        </div>

        <div class=orderinfo-wrapper>
          {{ configuration[activConfigStep].title }}: {{ configuration[activConfigStep].selectedOption.title }}
          <div class="order-position"
            v-for="(position,index) in this.configuration"
            :key="'pos'+index"
            :style="{'--indexOrder': index}">
            <div v-if="index + 1 < configuration.length">
              <div v-if="position.selectedOption.title">
                <div class="configtitle">{{ position.title }}: {{ position.selectedOption.title }}</div>
              </div>   
            </div>  
          </div>
        </div>
        
        
      </div>

      <div class="selection">
      <div v-if="activConfigStep + 1 < configuration.length" style="display: none;">
        <h3>Vyberte položku: {{ configuration[activConfigStep].title }}</h3>
        <p class="text-center">a klikněte na tlačítko "Další krok"</p>
      </div>
          <ProductConfiguratorOptions
            v-if="activConfigStep + 1  < configuration.length"
            :activeConfigStep="activConfigStep"
            :configuration="configuration"

            @chooseOption="selectOption" />

          <ProductConfiguratorOrder
            v-else
            :configuration="configuration" />
            <div class="actions">
              <button v-if="activConfigStep > 0" @click="prevPage"><< {{ configuration[activConfigStep - 1].title }}</button>
              &nbsp;
              <button class="primary" v-if="activConfigStep + 1 < configuration.length  &&  Object.keys(configuration[activConfigStep].selectedOption).length  !== 0 "  @click="nextPage">
                  <span v-if="activConfigStep + 2 === configuration.length">Dokončit</span>
                  <span v-else>{{ configuration[activConfigStep + 1].title }} >></span>
                </button>
            </div> 
      </div>

    </div>
  </div>
</template>

<script>
  import ProductConfiguratorProgress from './ProductConfiguratorProgress.vue'
  import ProductConfiguratorOptions from './ProductConfiguratorOptions.vue'
  import ProductConfiguratorOrder from './ProductConfiguratorOrder.vue'
  import { onMounted, ref } from 'vue'

  export default {
    mounted:function(){
        this.getInfoBoxWidth();

    
      if (localStorage.myconfig) {
        let retString = localStorage.getItem("myconfig");
       
       this.myarray = JSON.parse(retString);
  
       this.configuration[0].selectedOption = this.myarray[0];
       this.configuration[1].selectedOption = this.myarray[1];
       this.configuration[2].selectedOption = this.myarray[2];
       this.configuration[3].selectedOption = this.myarray[3];
       this.configuration[4].selectedOption = this.myarray[4];
      
        //console.log(JSON.parse(this.myarray));
        //console.log(JSON.parse(localStorage.getItem("configuration")));

       let activConfigStepTemp = -1;

        for (let i = 0; i <= this.myarray.length - 1; i++) {
            if (this.myarray[i] !== "{}") {
                activConfigStepTemp = i;
            }
        }

        this.activConfigStep = activConfigStepTemp;
      }
    

  },
     
    data: () => {
      return {
        myconfig: '',
        myarray: ["{}","{}","{}","{}","{}"],
        width : 340,
        height : 450,
        activConfigStep: 0,
        configuration: [
          {
            title: 'Základní barva',
            //selectedOption: { title: 'černá', img: 'barva-zakladni_08_cerna.png',description : ''},
            selectedOption: {},
            options: [
              { title: 'žlutá', img: 'barva-zakladni_08_zluta.png',description : ''},
              { title: 'oranžová', img: 'barva-zakladni_08_oranzova.png',description : ''},
              { title: 'červená', img: 'barva-zakladni_08_cervena.png',description : ''},
              { title: 'reflexní červená', img: 'barva-zakladni_08_reflexni-cervena.png',description : ''},
              { title: 'modrá', img: 'barva-zakladni_08_modra.png',description : ''},
              { title: 'temně modrá', img: 'barva-zakladni_08_temne-modra.png',description : ''},
              { title: 'černá', img: 'barva-zakladni_08_cerna.png',description : ''},

            ]
          },
          {
            title: 'Vrch s kapucí',
            selectedOption: {},
            options: [
              { title: 'žlutá', img: 'vrch-s-kapuci_08_zluta.png',description : ''},
              { title: 'oranžová', img: 'vrch-s-kapuci_08_oranzova.png',description : ''},
              { title: 'červená', img: 'vrch-s-kapuci_08_cervena.png',description : ''},
              { title: 'reflexní červená', img: 'vrch-s-kapuci_08_reflexni-cervena.png',description : ''},
              { title: 'modrá', img: 'vrch-s-kapuci_08_modra.png',description : ''},
              { title: 'temně modrá', img: 'vrch-s-kapuci_08_temne-modra.png',description : ''},
              { title: 'černá', img: 'vrch-s-kapuci_08_cerna.png',description : ''},
            ]  
          },
          {
            title: 'Boky',
            selectedOption: {},
            options: [
              { title: 'žlutá', img: 'boky_08_zluta.png',description : ''},
              { title: 'oranžová', img: 'boky_08_oranzova.png',description : ''},
              { title: 'červená', img: 'boky_08_cervena.png',description : ''},
              { title: 'reflexní červená', img: 'boky_08_reflexni-cervena.png',description : ''},
              { title: 'modrá', img: 'boky_08_modra.png',description : ''},
              { title: 'temně modrá', img: 'boky_08_temne-modra.png',description : ''},
              { title: 'černá', img: 'boky_08_cerna.png',description : ''},
            ]
          },
          {
            title: 'Rukávy',
            selectedOption: {},
            options: [
              { title: 'žlutá', img: 'rukavy_08_zluta.png',description : ''},
              { title: 'oranžová', img: 'rukavy_08_oranzova.png',description : ''},
              { title: 'červená', img: 'rukavy_08_cervena.png',description : ''},
              { title: 'reflexní červená', img: 'rukavy_08_reflexni-cervena.png',description : ''},
              { title: 'modrá', img: 'rukavy_08_modra.png',description : ''},
              { title: 'temně modrá', img: 'rukavy_08_temne-modra.png',description : ''},
              { title: 'černá', img: 'rukavy_08_cerna.png',description : ''},
            ]
          },
          {
            title: 'Hlavní zip',
            selectedOption: {},
            options: [
              { title: 'černá', img: 'zip_08_cerna.png',description : ''},
              { title: 'červená', img: 'zip_08_cervena.png',description : ''},
              { title: 'modrá', img: 'zip_08_modra.png',description : ''},
              { title: 'purpurová', img: 'zip_08_purpurova.png',description : ''},
              { title: 'žlutá', img: 'zip_08_zluta.png',description : ''},
            ]
          },  
           {
            title: '',
            selectedOption: { title: '' },
          }
        ]
      }
    },
    components: {
      ProductConfiguratorProgress,
      ProductConfiguratorOptions,
      ProductConfiguratorOrder
    },

    
    methods: {
      getInfoBoxWidth() {
        this.width = this.$refs.infoBox.clientWidth;
        if(this.width == 0) {
          this.width = window.innerWidth;
          if(this.width > 640) {this.width = 640;}
          console.log(this.width);
        }
      },

      nextPage() {        
        this.activConfigStep += 1;
        /*active_el:-1*/
        console.log(this.$route.query);
      },
      prevPage() {        
        this.activConfigStep -= 1;
      },
      selectOption(option) {
        this.configuration[this.activConfigStep].selectedOption = option;

        this.myarray[this.activConfigStep]= option;
        let mystring = JSON.stringify(this.myarray);
        localStorage.setItem("myconfig", mystring);

        //localStorage.configuration = this.configuration;
        

        /*if(this.activConfigStep + 1 === this.configuration.length) {
          let totalPrice = 0;
          this.configuration.forEach(element => {
            totalPrice += element.selectedOption.price;
          });

          this.configuration[this.activConfigStep]
            .selectedOption.price = totalPrice.toFixed(2);
        }*/
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap');
    .orderinfo-wrapper {clear:both;width:100%;padding-left:20px;text-align:left;margin-top:10px;}
    .order-position {display: none;}
    .images-wrapper {clear:both;width:100%;position:relative;display:flex;
      aspect-ratio:917/1006;
      background: url("../assets/images/faramugo-konfigurator-template.png");
      background-size: contain;
    }

    .text-center  {text-align:center;}
    .images-position {
      position: absolute;
      width:100%;
      aspect-ratio:917/1006;
    }
    .actions {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 70px;
    }


   .config-container button {
    outline: none;
    border: none;
    font-family: 'Inter', Arial;
    font-size: 1.2rem;
    padding: 8px 20px;
    border-radius: 5px;
    cursor: pointer;
    transition: opacity .5s ease-in-out;

  }


  .config-container button.primary {
    color: #000;
    font-weight:bold;
    background-color: #F5891F;
  }

  .configcontainer {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    padding: 0;
    /*width: calc(100% - 20px);*/
    min-height: 0px!important;
    font-family: 'Inter', Arial;
    font-size: 1rem;
    color: #333;
    background-size: cover;
    overflow: hidden;
  
  }

  .config-container {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));
    width: 100%;
    max-width: 1120px;
    max-width: calc(100vw - 20px);
    border-radius: 20px;
    overflow: hidden;
    /*box-shadow: 0 15px 30px rgba(0,0,0,.2),
                0 10px 10px rgba(0,0,0,.2); */
  }

  .selection {
    min-height: 480px;
    max-width: calc(100vw - 20px);
    background-color: rgba($color: #fff, $alpha: .8);
    overflow: hidden;

    h3 {
      text-align: center;
    }
  }

  .order-info {
    display: flex;
    justify-content: top;
    align-items: center;
    flex-direction: column;
    padding: 10px;
    text-align: center;
    max-width: calc(100vw - 40px);
   } 

   @media only screen and (max-width: 740px) {
      .config-container button {font-size:1rem;}
       .order-container  {padding-left:20px;padding-right:40px;}
      .actions {width:95%;}
  }
</style>
